import { useEffect, useState } from "react";
import CustomButton from "../button/Button"
import Modal from "../modal/Modal";
import "./VariantView.css";
import { toast } from "react-toastify";
import { useSelector, useDispatch } from "react-redux";
import { poExceptionVariantsEndpoint, poExceptionVariantShareUsersEndpoint } from "../../../common/endpoints";
import { getVariantsList } from "../../../redux/actions/VariantView/GetVariantsListSlice";
import DeleteIcon from '@mui/icons-material/Delete';
import ShareIcon from '@mui/icons-material/Share';
import { deleteVariantAPI } from "../../../redux/actions/VariantView/DeleteVariantSlice";
import { shareVariantUsers } from "../../../redux/actions/VariantView/GetShareUserSlice";
import { MultiDropdown } from "../MultiDropdown.js";
import { postShareVariant } from "../../../redux/actions/VariantView/PostShareVariantSlice";
import { Box, CircularProgress, Autocomplete, TextField } from "@mui/material";

export const ShowVariantViewModal = ({ openShowVariantModal, handleCloseShowVariantModal, data, tableType, onClickSelectVariant, appCode = "SC", plant, region }) => {
    const dispatch = useDispatch();
    const [variantsData, setVariantsData] = useState([])

    const onCloseVariantModal = () => {
        handleCloseShowVariantModal();
    }
    const onClickCancel = () => {
        handleCloseShowVariantModal();
    }
    const getVariantsData = async () => {
        try {
            const responseGetVariants = await dispatch(getVariantsList({
                dynamicEndpoint: `${poExceptionVariantsEndpoint}`,
                params: {
                    tableType: tableType,
                    plant: plant,
                    appCode: appCode,
                    region: region
                }
            }));
            if (responseGetVariants?.meta?.requestStatus === 'fulfilled') {
                setVariantsData(responseGetVariants?.payload?.variants)
            } else {
                console.error('Failed to fetch data:', responseGetVariants?.error);
                toast.error(responseGetVariants?.payload?.errorMessage, {
                    autoClose: 2000,
                });
            }
        } catch (error) {
            console.error('API error:', error);
            toast.error(error, {
                autoClose: 2000,
            });
        }
    }


    useEffect(() => {
        if (openShowVariantModal === true) {
            getVariantsData();
        }
    }, [openShowVariantModal]) // eslint-disable-line react-hooks/exhaustive-deps

    const deleteSelectedVariant = async (id) => {

        try {
            const responseDeleteVariant = await dispatch(deleteVariantAPI({
                dynamicEndpoint: `${poExceptionVariantsEndpoint}/${id}`,
                params: { role: localStorage.getItem("userRole") }
            }));
            if (responseDeleteVariant?.meta?.requestStatus === 'fulfilled') {
                toast.success(responseDeleteVariant?.payload, {
                    autoClose: 2000,
                });
                getVariantsData();
            } else {
                console.error('Failed to fetch data:', responseDeleteVariant?.error);
                toast.error(responseDeleteVariant?.payload?.errorMessage, {
                    autoClose: 2000,
                });
            }
        } catch (error) {
            console.error('API error:', error);
            toast.error(error, {
                autoClose: 2000,
            });
        }
    }
    const onClickSelectButton = (item) => {
        onClickSelectVariant(item);
        onClickCancel();
    }

    return (
        <>
            <Modal
                className="showVariantModal_cls"
                open={openShowVariantModal}
                handleClose={onCloseVariantModal}
                title="Variants Catalog"
                fullWidth={true}
                action={
                    <ShowVariantFooter
                        onClickCancel={onClickCancel}
                    />
                }
                content={
                    <ShowVariantContent
                        variantsData={variantsData}
                        tableType={tableType}
                        plant={plant}
                        region={region}
                        deleteSelectedVariant={deleteSelectedVariant}
                        onClickSelectButton={onClickSelectButton}
                        onClickCancel={onClickCancel}
                    />
                }
            />
        </>
    )
}

const ShowVariantFooter = ({ onClickCancel }) => {
    return (
        <div className='finalLTupdatedfooter-btn-wrapper'>
            <CustomButton
                label="Close"
                type="primary"
                maxWidth="80px"
                onClick={onClickCancel}
            />
        </div>
    );
};
const ShowVariantContent = ({ variantsData, deleteSelectedVariant, onClickSelectButton, tableType, plant, region }) => {
    const dispatch = useDispatch();
    const [isShareClicked, setIsShareClicked] = useState(false);
    const [selectedShareID, setSelectedShareID] = useState("");
    const [role, setRole] = useState(null);
    const [usersByRole, setUsersByRole] = useState({});
    const [users, setUsers] = useState([]);
    const [shareResponse, setShareResponse] = useState("");
    const userEmail = localStorage.getItem("userEmail");

    const DeleteVariantSlice = useSelector((state) => state.DeleteVariantSlice);
    const GetShareUserSlice = useSelector((state) => state.GetShareUserSlice);
    const PostShareVariantSlice = useSelector((state) => state.PostShareVariantSlice);
    const GetVariantsListSlice = useSelector((state) => state.GetVariantsListSlice);
    const isLoading =
        DeleteVariantSlice?.loading ||
        GetShareUserSlice?.loading ||
        PostShareVariantSlice?.loading ||
        GetVariantsListSlice?.loading;

    const [formData, setFormData] = useState({
        selectedUsers: [],
    })

    const getUniqueValues = (data = []) => {
        if (Array.isArray(data) && data.length > 0) {
            return data
                .filter(item => item && item.name && item.email)
                .map(item => ({ label: item.name, value: item.email, title: item.name }));
        } else {
            return [];
        }
    };

    const handleClickBack = () => {
        setIsShareClicked(false);
        setShareResponse("");
        setFormData({ selectedUsers: [] })
    }
    const deleteVariant = (id) => {
        deleteSelectedVariant(id)
    }
    const shareVariant = (id) => {
        setIsShareClicked(true);
        setSelectedShareID(id)
    }

    const handleSelectedItemsChange = (name, newSelectedItems) => {
        setFormData((prevData) => ({
            ...prevData,
            [name]: newSelectedItems,
        }));
    }

    const handleShareVariantAPI = async () => {
        const reqBodyData = [];
        formData?.selectedUsers?.forEach((item) => {
            reqBodyData.push({ name: item.title, email: item.value });
        });

        const reqBody = {
            "userEmail": userEmail,
            "tableType": tableType,
            "sharedUsers": reqBodyData,
            "userVariantMapSeqId": selectedShareID
        }
        try {
            const responseShareVariant = await dispatch(postShareVariant({
                dynamicEndpoint: `${poExceptionVariantsEndpoint}/share`,
                params: {
                    role: localStorage.getItem("userRole"),
                    region: region,
                },
                data: reqBody,
            }));
            if (responseShareVariant?.meta?.requestStatus === 'fulfilled') {
                setShareResponse(responseShareVariant?.payload);
            } else {
                console.error('Failed to fetch data:', responseShareVariant?.error);
                toast.error(responseShareVariant?.payload?.errorMessage, {
                    autoClose: 2000,
                });
            }
        } catch (error) {
            console.error('API error:', error);
            toast.error(error, {
                autoClose: 2000,
            });
        }
    }
    const handleClickSelect = (item) => {
        onClickSelectButton(item);
    }
    const roles = ["GlobalPlanner", "GlobalViewer", "AMERPlanner", "EMEAPlanner", "APACPlanner", "AMERViewer", "EMEAViewer", "APACViewer"];
    const handleRoleChange = async (event, newRole) => {
        setRole(newRole);
        setFormData({ selectedUsers: [] })
        if (!newRole) return;

        if (usersByRole[newRole]) {
            setUsers(usersByRole[newRole]);
            return;
        }

        try {
            const params = {
                shareVariantRole: newRole,
            };
            params.plant = '';
            params.scRegion = region;
            const responseGetVariants = await dispatch(shareVariantUsers({
                dynamicEndpoint: `${poExceptionVariantShareUsersEndpoint}`,
                params: params,
            }));
            if (responseGetVariants?.meta?.requestStatus === 'fulfilled') {
                setUsersByRole((prev) => ({ ...prev, [newRole]: responseGetVariants?.payload }));
                setUsers(responseGetVariants?.payload);
            } else {
                console.error('Failed to fetch data:', responseGetVariants?.error);
                toast.error(responseGetVariants?.payload?.errorMessage, {
                    autoClose: 2000,
                });
            }
        } catch (error) {
            console.error('API error:', error);
            toast.error(error, {
                autoClose: 2000,
            });
        }
    }
    const filteredUsers = Array.isArray(users)
        ? users.filter((user) => user && user.email && user.email !== userEmail)
        : [];

    return (
        isLoading ?
            <Box style={{ textAlign: 'center', height: 100, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <CircularProgress color="inherit" style={{ width: '20px', height: '20px', textAlign: 'center', marginRight: 30 }} />
            </Box>
            :
            <div style={{ overflowX: "auto" }}>{
                isShareClicked ?
                    <div>
                        {shareResponse === "" ?
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <div style={{ display: 'flex', gap: 40 }}>
                                    <div className="parameter-dropdowns" style={{ width: 400, display: 'flex' }}>
                                        <span>Select Role</span>
                                        <Autocomplete
                                            disableClearable={true}
                                            options={roles}
                                            value={role}
                                            onChange={handleRoleChange}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    placeholder="Select Role"
                                                    variant="outlined"
                                                    InputProps={{
                                                        ...params.InputProps,
                                                        sx: {
                                                            width: '100%',
                                                            backgroundColor: "#fff",
                                                            overflow: "hidden",
                                                            whiteSpace: "nowrap",
                                                            textOverflow: "ellipsis",
                                                        }
                                                    }}
                                                />
                                            )}
                                        />
                                    </div>
                                    <div className="parameter-dropdowns" style={{ width: 400, display: 'flex' }}>
                                        <span>Select Users</span>
                                        <MultiDropdown
                                            id="selectedUsers"
                                            name="selectedUsers"
                                            options={getUniqueValues(filteredUsers, 'name') || []}
                                            selectedItemsData={formData?.selectedUsers || []}
                                            onChangeItems={handleSelectedItemsChange}
                                            disabled={filteredUsers?.length === 0}
                                        />
                                    </div>
                                </div>
                                <div className='finalLTupdatedfooter-warning-btn-wrapper'>
                                    <CustomButton
                                        label="Back"
                                        type="primary"
                                        maxWidth="80px"
                                        onClick={handleClickBack}
                                    />
                                    <CustomButton
                                        label="Share"
                                        type="secondary"
                                        maxWidth="80px"
                                        onClick={handleShareVariantAPI}
                                        disabled={formData?.selectedUsers?.length === 0}
                                    />
                                </div>
                            </div>
                            :
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <p style={{whiteSpace: 'pre-line'}}> {shareResponse}</p>
                                <div className='finalLTupdatedfooter-warning-btn-wrapper'>
                                    <CustomButton
                                        label="Back"
                                        type="primary"
                                        maxWidth="80px"
                                        onClick={handleClickBack}
                                    />
                                </div>
                            </div>
                        }
                    </div> :
                    variantsData?.length > 0 ? (
                        <table style={{ width: "100%", borderCollapse: "collapse" }}>
                            <thead>
                                <tr style={{ backgroundColor: "#f5f5f5" }}>
                                    <th style={{ border: "1px solid #bcbcbc", padding: "8px", textAlign: "left", whiteSpace: "normal", wordBreak: "break-word", maxWidth: "200px" }}>Variant Name</th>
                                    <th style={{ border: "1px solid #bcbcbc", padding: "8px", textAlign: "left", whiteSpace: "normal", wordBreak: "break-word", maxWidth: "400px" }}>Variant Description</th>
                                    <th style={{ border: "1px solid #bcbcbc", padding: "8px", textAlign: "left", whiteSpace: "normal", wordBreak: "break-word", maxWidth: "150px" }}>Created On</th>
                                    <th style={{ border: "1px solid #bcbcbc", padding: "8px", textAlign: "left", whiteSpace: "normal", wordBreak: "break-word", maxWidth: "150px" }}>Modified On</th>
                                    <th style={{ border: "1px solid #bcbcbc", padding: "8px", textAlign: "left", width: "200px" }}>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {variantsData.map((item) => (
                                    <tr key={item?.userVariantMapSeqId}>
                                        <td style={{ border: "1px solid #bcbcbc", padding: "8px", textAlign: "left", whiteSpace: "normal", wordBreak: "break-word", maxWidth: "200px" }}>{item?.variantName}</td>
                                        <td style={{ border: "1px solid #bcbcbc", padding: "8px", textAlign: "left", whiteSpace: "normal", wordBreak: "break-word", maxWidth: "400px" }}>{item?.variantDescription}</td>
                                        <td style={{ border: "1px solid #bcbcbc", padding: "8px", textAlign: "left", whiteSpace: "normal", wordBreak: "break-word", maxWidth: "150px" }}>{item?.createdAt}</td>
                                        <td style={{ border: "1px solid #bcbcbc", padding: "8px", textAlign: "left", whiteSpace: "normal", wordBreak: "break-word", maxWidth: "150px" }}>{item?.modifiedAt}</td>
                                        <td style={{ border: "1px solid #bcbcbc", padding: "8px", textAlign: "center", width: "200px" }}>
                                            <div style={{ display: 'flex', justifyContent: 'center', gap: 10 }}>
                                                <span><CustomButton
                                                    label="Select"
                                                    type="secondary"
                                                    maxWidth="100px"
                                                    onClick={() => handleClickSelect(item)}
                                                /></span>
                                                <span style={{ cursor: "pointer", marginRight: "12px" }} onClick={() => shareVariant(item?.userVariantMapSeqId)}><ShareIcon /></span>
                                                <span style={{ cursor: "pointer" }} onClick={() => deleteVariant(item?.userVariantMapSeqId)}><DeleteIcon /></span>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )
                        :
                        <div style={{ textAlign: 'center' }}>
                            <p><b>No Variants Available</b></p>
                        </div>
            }
            </div >
    )
};